import type { FC } from 'react';

import RegulatorBetId from '@swf/sports/components/RegulatorBetId/RegulatorBetId';

import styles from './RegulatorIdRow.scss';

interface Props {
  regulatorId?: string;
}

export const RegulatorIdRow: FC<Props> = ({ regulatorId }) =>
  regulatorId ? (
    <p className={styles.container}>
      <RegulatorBetId regulatorId={regulatorId} />
    </p>
  ) : null;
